import React from "react";
import { useSelector } from "react-redux";

import { getExistingLizardRasterRain } from "../../state/existingEvents";

import ExistingLizardRasterRainCard from "./ExistingLizardRasterRainBarCard";

const ExistingLizardRasterRain = () => {
  const existingLizardRasterRainEvents = useSelector(getExistingLizardRasterRain);
  return (
    <div>
      {existingLizardRasterRainEvents.map((existingLizardRasterRain) => {
        return (
          <ExistingLizardRasterRainCard
            existingLizardRasterRain={existingLizardRasterRain}
            key={existingLizardRasterRain.uid}
          />
        );
      })}
    </div>
  );
};

export default ExistingLizardRasterRain;
